import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';

// obtener Data libro Contable
export async function fetchRepor({commit, state}) {
     console.log(state.params);
    await $http.get('/api/informe-despachos', { params : state.params})
        .then((response) => {
            commit('setReport', response.data);
            state.loading.module = false;
        })
        .catch((error) => {
            if (state.loading.module){
                commit('setLoading',false);
            }
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}




// WEBPACK FOOTER //
// ./src/modules/report-picking/actions.js